module.exports = __webpack_public_path__ + "static/compiler_complaint-34a888f72afc1a1a854b5807ea7bbb62.png";